import qs from 'qs'
import request from '@/utils/request'

function toFormData (data = {}) {
  const params = {}
  Object.keys(data).forEach(key => {
    const value = data[key]
    if (value !== undefined && value !== null && value !== '') {
      params[key] = Array.isArray(value) || typeof value === 'object' ? JSON.stringify(value) : value
    }
  })
  return qs.stringify(params)
}

// ===================== 用户管理 =====================

export function getRtUserList (data) {
  return request({
    url: '/rtUser/getRtUserList',
    method: 'post',
    data: toFormData(data)
  })
}

export function getRtUserDetails (data) {
  return request({
    url: '/rtUser/getRtUserDetails',
    method: 'post',
    data: toFormData(data)
  })
}

export function addRtUser (data) {
  return request({
    url: '/rtUser/addRtUser',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateRtUser (data) {
  return request({
    url: '/rtUser/updateRtUser',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateRtUserPw (data) {
  return request({
    url: '/rtUser/updateRtUserPw',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateRtUserPwAdmin (data) {
  return request({
    url: '/rtUser/updateRtUserPwAdmin',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateRtUserHeader (data) {
  return request({
    url: '/rtUser/updateRtUserHeader',
    method: 'post',
    data: toFormData(data)
  })
}

export function deleteRtUser (data) {
  return request({
    url: '/rtUser/deleteRtUser',
    method: 'post',
    data: toFormData(data)
  })
}

// ===================== 角色管理 =====================

export function getRtRoleList (data) {
  return request({
    url: '/rtRole/getRtRoleList',
    method: 'post',
    data: toFormData(data)
  })
}

export function getRtRoleDetails (data) {
  return request({
    url: '/rtRole/getRtRoleDetails',
    method: 'post',
    data: toFormData(data)
  })
}

export function addRtRole (data) {
  return request({
    url: '/rtRole/addRtRole',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateRtRole (data) {
  return request({
    url: '/rtRole/updateRtRole',
    method: 'post',
    data: toFormData(data)
  })
}

export function deleteRtRole (data) {
  return request({
    url: '/rtRole/deleteRtRole',
    method: 'post',
    data: toFormData(data)
  })
}

export function getRtRoleAuthList (data) {
  return request({
    url: '/rtRole/getRtRoleAuthList',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateRtRoleAuth (data) {
  return request({
    url: '/rtRole/updateRtRoleAuth',
    method: 'post',
    data: toFormData(data)
  })
}

// ===================== 角色用户管理 =====================

// 获取角色下用户列表
export function getRtRoleUserList (data) {
  return request({
    url: '/rtRoleUser/getRtRoleUserList',
    method: 'post',
    data: toFormData(data)
  })
}

// 编辑角色下的用户（批量绑定）
export function updateRtRoleUserMulti (data) {
  return request({
    url: '/rtRoleUser/updateRtRoleUserMulti',
    method: 'post',
    data: toFormData(data)
  })
}

// 删除角色下的用户
export function deleteRtRoleUser (data) {
  return request({
    url: '/rtRoleUser/deleteRtRoleUser',
    method: 'post',
    data: toFormData(data)
  })
}

// ===================== 部门管理 =====================

export function getDepartmentList (data) {
  return request({
    url: '/rtDepartment/getDepartmentList',
    method: 'post',
    data: toFormData(data)
  })
}

export function addDepartment (data) {
  return request({
    url: '/rtDepartment/addDepartment',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateDepartment (data) {
  return request({
    url: '/rtDepartment/updateDepartment',
    method: 'post',
    data: toFormData(data)
  })
}

export function deleteDepartment (data) {
  return request({
    url: '/rtDepartment/deleteDepartment',
    method: 'post',
    data: toFormData(data)
  })
}

// ===================== 菜单权限管理 =====================

export function getRtAuthList (data) {
  return request({
    url: '/rtAuth/getRtAuthList',
    method: 'post',
    data: toFormData(data)
  })
}

export function getRtAuthTree (data) {
  return request({
    url: '/rtAuth/getRtAuthTree',
    method: 'post',
    data: toFormData(data)
  })
}

export function addRtAuth (data) {
  return request({
    url: '/rtAuth/addRtAuth',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateRtAuth (data) {
  return request({
    url: '/rtAuth/updateRtAuth',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateRtAuthParent (data) {
  return request({
    url: '/rtAuth/updateRtAuthParent',
    method: 'post',
    data: toFormData(data)
  })
}

export function deleteRtAuth (data) {
  return request({
    url: '/rtAuth/deleteRtAuth',
    method: 'post',
    data: toFormData(data)
  })
}
